// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import NationalityTable from "../../DataTables/MasterData/Nationality/NationalityTable";

// Modals
import CreateNationalityModal from "../../UiKits/Modal/MasterData/Nationality/CreateNationality";

const NationalityContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="Nationality"
        parent="Master Data / Personal Information"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Nationality Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage nationalities options used throughout the HRIS for
                  employee and applicant personal information.
                </P>
                <CreateNationalityModal />
                <NationalityTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NationalityContainer;
